import { fetchFromAPI } from './common.js';



async function getUserDetails(userId) {
    try {
        // Step 1: Get User Details from API
        console.log("Fetching user details for userId:", userId);
        const users = await fetchFromAPI(`/api/users/${userId}`);

        if (!users || users.length === 0) {
            throw new Error('User not found');
        }

        const user = users[0]; // Assuming the API returns an array with one user
        console.log("Received user details from API:", user);

        // Extract details, including the new fields
        // Extract details, including the new fields
        const practiceId = user?.practiceId; // Added optional chaining
        const bAdminUser = user?.bAdminUser !== undefined ? user.bAdminUser : true; // Added null check with default
        const bGroupAdmin = user?.bGroupAdmin !== undefined ? user.bGroupAdmin : false; // Added null check with default
        const groupAdminOrg = user?.groupAdminOrg !== undefined ? user.groupAdminOrg : null; // Added null check with default
        const bNonVoipOnboarding = user?.bNonVoipOnboarding !== undefined ? user.bNonVoipOnboarding : false; // Added null check with default
        const allowedPractices = user?.allowedPracticeIds !== undefined ? user.allowedPracticeIds : []; // Added null check with default
        const lastSelectedPracticeId = user?.lastSelectedPracticeId || null;

        if (!practiceId) {
            throw new Error('Practice ID not found for user');
        }

        // Return the comprehensive user details object
        return {
            userId,
            practiceId,
            bAdminUser,
            bGroupAdmin, // Include in return
            groupAdminOrg, // Include in return
            bNonVoipOnboarding,
            allowedPractices,
            lastSelectedPracticeId,
        };
    } catch (error) {
        console.error('Error fetching user details:', error);
        throw error;
    }
}

export { getUserDetails, fetchFromAPI };


